import gql from "graphql-tag";
import emailsTemplate from "queries/fragments/emailsTemplate";
const GET_EMAILS_TEMPLATES = gql `
  ${emailsTemplate}

  query getEmailsTemplates {
    getEmailsTemplates {
      ...EmailsTemplate
    }
  }
`;
export default GET_EMAILS_TEMPLATES;
